<template>
  <div class="card">
    <img class="logo" src="/images/terrassa-logo.png" alt="Logo Terrassa" />
    <h2>Accés a l'app de Vetlles</h2>
    <form @submit.prevent="login">
      <div class="login-form">
        <input
          v-model="username"
          class="form-input"
          type="text"
          placeholder="Nom d'usuari"
          autofocus
        />
        <input
          v-model="password"
          class="form-input"
          type="password"
          placeholder="Mot de pas"
        />
        <button type="submit" class="crea-button">Entra</button>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import axios, { AxiosError } from "axios";
import { defineComponent, ref } from "vue";
import CustomSwal from "../custom-swal";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const router = useRouter();

    const username = ref("");
    const password = ref("");

    const login = () => {
      axios
        .post(
          "/api/auth/login",
          {
            Username: username.value,
            Password: password.value,
          },
          { withCredentials: true },
        )
        .then(() => {
          router.push({ name: "bifurcacion" }).then(() => {
            window.location.reload();
          });
        })
        .catch((e: AxiosError) => {
          if (401 === e.response?.status) {
            CustomSwal.fire({
              icon: "warning",
              title: "Credencials incorrectes",
            });
          } else {
            CustomSwal.fire({
              icon: "error",
              title: "S'ha produït un error!",
              text: "Posi's en contacte amb els administradors de l'aplicació",
            });
          }
        });
    };

    return {
      username,
      password,
      login,
    };
  },
});
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2em;

  padding: 1em;
  border-radius: $rounded-border;

  background-color: $bg-color;

  width: 80%;

  @media (max-width: 768px) {
    width: 96%;
  }
}

.logo {
  width: 16em;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1em;

  width: 16em;
}

.crea-button {
  @include button($primary-color);
}
</style>
